export function getDayBeforeYesterday() {
    var date = new Date();
    date.setDate(date.getDate()-2);
    var day = date.toLocaleString('en-us', {  weekday: 'long' });

    return day;
}


// WEBPACK FOOTER //
// ./src/utils/DateHelper.js